import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ContactSection = () => {
    let link = "mailto:info@mi-expert.com?subject=" 
    + encodeURIComponent("Request for MiChat Information")+ "&body="
    + encodeURIComponent("Hi MiChat Team,\n\nI would like to know more about MiChat. Please provide me with more information on how I can get started.\n\nThank you.");

    let waLink = "https://wa.me/85265554706?text="
    + encodeURIComponent("Hi MiChat Team,\n\nI would like to know more about MiChat. Please provide me with more information on how I can get started.\n\nThank you.");

    const { t } = useTranslation();
    return (
        <section id="contact" className="py-20">
            <div className="container mx-auto px-6">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="max-w-lg mx-auto text-center"
                >
                    <h2 className="text-3xl font-bold mb-8">{t("Ready to Transform Your Customer Service?")}</h2>
                    <p className="text-gray-600 mb-8">
                        {t("Contact us today and learn how MiChat can help your business provide better customer support.")}
                    </p>
                    <a href={waLink}>
                    <button className="bg-blue-500 text-white px-8 py-3 rounded-full text-lg hover:bg-blue-600 transition duration-300">
                        {t("Contact Sales")}
                    </button>
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default ContactSection;

export {};
